import { render, staticRenderFns } from "./UserSettingReportHeimao.vue?vue&type=template&id=70bf4cbb&scoped=true&"
import script from "./UserSettingReportHeimao.vue?vue&type=script&lang=js&"
export * from "./UserSettingReportHeimao.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingReportHeimao.vue?vue&type=style&index=0&id=70bf4cbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf4cbb",
  null
  
)

export default component.exports